// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IAggregatedPnlMetricDto,
  IAutoInvestmentSchedulerResponseDto,
  IErrorDto,
  IGenericErrorDto,
  IInstrumentCategoryTypeDto,
  IInstrumentDto,
  IInvestmentCountryDto,
  IInvestorBaseDto,
  IInvestorDto,
  IPageInstrumentDto,
  IPageMoneyTransferResponseDto,
  IPagePublicOrderDto,
  IPerformanceHistoryDto,
  IPortfolioFundAssetDto,
  IQuestionnaireDto,
  IRiskToleranceModelResponseDto,
  ITradingAmountsDto,
} from '../models/index';
import {
    IAggregatedPnlMetricDtoFromJSON,
    IAggregatedPnlMetricDtoToJSON,
    IAutoInvestmentSchedulerResponseDtoFromJSON,
    IAutoInvestmentSchedulerResponseDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    IInstrumentCategoryTypeDtoFromJSON,
    IInstrumentCategoryTypeDtoToJSON,
    IInstrumentDtoFromJSON,
    IInstrumentDtoToJSON,
    IInvestmentCountryDtoFromJSON,
    IInvestmentCountryDtoToJSON,
    IInvestorBaseDtoFromJSON,
    IInvestorBaseDtoToJSON,
    IInvestorDtoFromJSON,
    IInvestorDtoToJSON,
    IPageInstrumentDtoFromJSON,
    IPageInstrumentDtoToJSON,
    IPageMoneyTransferResponseDtoFromJSON,
    IPageMoneyTransferResponseDtoToJSON,
    IPagePublicOrderDtoFromJSON,
    IPagePublicOrderDtoToJSON,
    IPerformanceHistoryDtoFromJSON,
    IPerformanceHistoryDtoToJSON,
    IPortfolioFundAssetDtoFromJSON,
    IPortfolioFundAssetDtoToJSON,
    IQuestionnaireDtoFromJSON,
    IQuestionnaireDtoToJSON,
    IRiskToleranceModelResponseDtoFromJSON,
    IRiskToleranceModelResponseDtoToJSON,
    ITradingAmountsDtoFromJSON,
    ITradingAmountsDtoToJSON,
} from '../models/index';

export interface ApproveAndOnboardInvestorRequest {
    model?: ApproveAndOnboardInvestorModelEnum;
}

export interface DeleteAutoInvestmentSchedulerRequest {
    id: number;
}

export interface GetAutoInvestmentSchedulerRequest {
    investorAccountId: number;
}

export interface GetClosestPerformanceHistoryRequest {
    daysBack?: number;
}

export interface GetInvestorByEmployeeIdRequest {
    employeeId?: number;
}

export interface GetInvestorsByEmployeeIdsRequest {
    employeeIds: Set<number>;
}

export interface GetMoneyTransfers1Request {
    startDate?: Date;
    endDate?: Date;
    statuses?: Set<GetMoneyTransfers1StatusesEnum>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetOrders1Request {
    instrumentIds?: Set<number>;
    startDate?: Date;
    endDate?: Date;
    status?: Set<GetOrders1StatusEnum>;
    minAmount?: number;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface PatchQuestionnaireRequest {
    iQuestionnaireDto: IQuestionnaireDto;
}

export interface ProposePortfolioRequest {
    investorId: number;
    riskModel: ProposePortfolioRiskModelEnum;
    amount: number;
}

export interface RetrieveSelfDirectedInstrumentsRequest {
    searchValue?: string;
    categoryTypes?: Set<RetrieveSelfDirectedInstrumentsCategoryTypesEnum>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface UpdateRiskToleranceModelRequest {
    id: number;
    body: string;
}

/**
 * InvestmentServiceServiceApi - interface
 * 
 * @export
 * @interface InvestmentServiceServiceApiInterface
 */
export interface InvestmentServiceServiceApiInterface {
    /**
     * 
     * @summary Approve tolerance model - UI step 5
     * @param {'CONSERVATIVE' | 'MODERATELY_CONSERVATIVE' | 'MODERATE' | 'MODERATELY_AGGRESSIVE' | 'AGGRESSIVE'} [model] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    approveAndOnboardInvestorRaw(requestParameters: ApproveAndOnboardInvestorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestorDto>>;

    /**
     * Approve tolerance model - UI step 5
     */
    approveAndOnboardInvestor(requestParameters: ApproveAndOnboardInvestorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestorDto>;

    /**
     * 
     * @summary Delete investment scheduler by id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    deleteAutoInvestmentSchedulerRaw(requestParameters: DeleteAutoInvestmentSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete investment scheduler by id
     */
    deleteAutoInvestmentScheduler(requestParameters: DeleteAutoInvestmentSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Retrieve allowed investments countries for investments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    getAllowedInvestmentsCountriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IInvestmentCountryDto>>>;

    /**
     * Retrieve allowed investments countries for investments
     */
    getAllowedInvestmentsCountries(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IInvestmentCountryDto>>;

    /**
     * 
     * @summary Get auto investment scheduler by investor account id
     * @param {number} investorAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    getAutoInvestmentSchedulerRaw(requestParameters: GetAutoInvestmentSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAutoInvestmentSchedulerResponseDto>>;

    /**
     * Get auto investment scheduler by investor account id
     */
    getAutoInvestmentScheduler(requestParameters: GetAutoInvestmentSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAutoInvestmentSchedulerResponseDto>;

    /**
     * 
     * @summary Get performance history
     * @param {number} [daysBack] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    getClosestPerformanceHistoryRaw(requestParameters: GetClosestPerformanceHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPerformanceHistoryDto>>>;

    /**
     * Get performance history
     */
    getClosestPerformanceHistory(requestParameters: GetClosestPerformanceHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPerformanceHistoryDto>>;

    /**
     * 
     * @summary Get investor info with pending trade sum by employee id
     * @param {number} [employeeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    getInvestorByEmployeeIdRaw(requestParameters: GetInvestorByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestorDto>>;

    /**
     * Get investor info with pending trade sum by employee id
     */
    getInvestorByEmployeeId(requestParameters: GetInvestorByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestorDto>;

    /**
     * 
     * @summary Get investors by employee ids
     * @param {Set<number>} employeeIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    getInvestorsByEmployeeIdsRaw(requestParameters: GetInvestorsByEmployeeIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IInvestorBaseDto>>>;

    /**
     * Get investors by employee ids
     */
    getInvestorsByEmployeeIds(requestParameters: GetInvestorsByEmployeeIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IInvestorBaseDto>>;

    /**
     * 
     * @summary Get money transfer page
     * @param {Date} [startDate] 
     * @param {Date} [endDate] 
     * @param {Set<'CREATED_INTERNAL' | 'CREATED_EXTERNAL' | 'SUCCESSFUL_EXTERNAL' | 'PENDING_PAYMENT' | 'PAID' | 'FAILED_EXTERNAL'>} [statuses] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    getMoneyTransfers1Raw(requestParameters: GetMoneyTransfers1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageMoneyTransferResponseDto>>;

    /**
     * Get money transfer page
     */
    getMoneyTransfers1(requestParameters: GetMoneyTransfers1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageMoneyTransferResponseDto>;

    /**
     * 
     * @summary Retrieve investor orders
     * @param {Set<number>} [instrumentIds] 
     * @param {Date} [startDate] 
     * @param {Date} [endDate] 
     * @param {Set<'FILLED' | 'PARTIAL_FILL' | 'REJECTED' | 'CANCELED' | 'NEW' | 'PENDING_CANCEL' | 'EXPIRED' | 'WAITING_APPROVAL' | 'PAID'>} [status] 
     * @param {number} [minAmount] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    getOrders1Raw(requestParameters: GetOrders1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPagePublicOrderDto>>;

    /**
     * Retrieve investor orders
     */
    getOrders1(requestParameters: GetOrders1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPagePublicOrderDto>;

    /**
     * 
     * @summary Retrieve PNL metrics for the investor.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    getPnlMetricsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAggregatedPnlMetricDto>>;

    /**
     * Retrieve PNL metrics for the investor.
     */
    getPnlMetrics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAggregatedPnlMetricDto>;

    /**
     * 
     * @summary Fetch trading history for the current investor account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    getTradingAmountsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ITradingAmountsDto>>;

    /**
     * Fetch trading history for the current investor account
     */
    getTradingAmounts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ITradingAmountsDto>;

    /**
     * 
     * @summary Save employment profile and investor profile - UI step 3
     * @param {IQuestionnaireDto} iQuestionnaireDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    patchQuestionnaireRaw(requestParameters: PatchQuestionnaireRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestorDto>>;

    /**
     * Save employment profile and investor profile - UI step 3
     */
    patchQuestionnaire(requestParameters: PatchQuestionnaireRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestorDto>;

    /**
     * 
     * @summary Propose investment portfolios
     * @param {number} investorId 
     * @param {'CONSERVATIVE' | 'MODERATELY_CONSERVATIVE' | 'MODERATE' | 'MODERATELY_AGGRESSIVE' | 'AGGRESSIVE'} riskModel 
     * @param {number} amount 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    proposePortfolioRaw(requestParameters: ProposePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPortfolioFundAssetDto>>>;

    /**
     * Propose investment portfolios
     */
    proposePortfolio(requestParameters: ProposePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPortfolioFundAssetDto>>;

    /**
     * 
     * @summary Retrieve available instrument ids for current investor account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    retrieveCurrentInvestorAccountInstrumentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Set<IInstrumentDto>>>;

    /**
     * Retrieve available instrument ids for current investor account
     */
    retrieveCurrentInvestorAccountInstruments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Set<IInstrumentDto>>;

    /**
     * 
     * @summary Retrieve all instrument category types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    retrieveInstrumentCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IInstrumentCategoryTypeDto>>>;

    /**
     * Retrieve all instrument category types
     */
    retrieveInstrumentCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IInstrumentCategoryTypeDto>>;

    /**
     * 
     * @summary Retrieve instruments by search value and categories
     * @param {string} [searchValue] 
     * @param {Set<'SHORT_TERM_BOND' | 'INTERMEDIATE_CORE_BOND' | 'INTERMEDIATE_CORE_PLUS_BOND' | 'INFLATION_PROTECTED_BOD' | 'GLOBAL_BOND' | 'HIGH_YIELD_BOND' | 'LARGE_VALUE' | 'LARGE_BLEND' | 'LARGE_GROWTH' | 'MID_CAP_VALUE' | 'MID_CAP_BLEND' | 'MID_CAP_GROWTH' | 'SMALL_VALUE' | 'SMALL_BLEND' | 'SMALL_GROWTH' | 'REAL_ESTATE' | 'FOREIGN_LARGE_BLEND' | 'FOREIGN_SMALL_MID_BLEND' | 'DIVERSIFIED_EMERGING_MKTS' | 'MONEY_MARKET_FUND'>} [categoryTypes] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    retrieveSelfDirectedInstrumentsRaw(requestParameters: RetrieveSelfDirectedInstrumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageInstrumentDto>>;

    /**
     * Retrieve instruments by search value and categories
     */
    retrieveSelfDirectedInstruments(requestParameters: RetrieveSelfDirectedInstrumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageInstrumentDto>;

    /**
     * 
     * @summary Update risk tolerance model
     * @param {number} id 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvestmentServiceServiceApiInterface
     */
    updateRiskToleranceModelRaw(requestParameters: UpdateRiskToleranceModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRiskToleranceModelResponseDto>>;

    /**
     * Update risk tolerance model
     */
    updateRiskToleranceModel(requestParameters: UpdateRiskToleranceModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRiskToleranceModelResponseDto>;

}

/**
 * 
 */
export class InvestmentServiceServiceApi extends runtime.BaseAPI implements InvestmentServiceServiceApiInterface {

    /**
     * Approve tolerance model - UI step 5
     */
    async approveAndOnboardInvestorRaw(requestParameters: ApproveAndOnboardInvestorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestorDto>> {
        const queryParameters: any = {};

        if (requestParameters['model'] != null) {
            queryParameters['model'] = requestParameters['model'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investments/flows/approve`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvestorDtoFromJSON(jsonValue));
    }

    /**
     * Approve tolerance model - UI step 5
     */
    async approveAndOnboardInvestor(requestParameters: ApproveAndOnboardInvestorRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestorDto> {
        const response = await this.approveAndOnboardInvestorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete investment scheduler by id
     */
    async deleteAutoInvestmentSchedulerRaw(requestParameters: DeleteAutoInvestmentSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAutoInvestmentScheduler().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investment-schedulers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete investment scheduler by id
     */
    async deleteAutoInvestmentScheduler(requestParameters: DeleteAutoInvestmentSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAutoInvestmentSchedulerRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve allowed investments countries for investments
     */
    async getAllowedInvestmentsCountriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IInvestmentCountryDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/countries`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IInvestmentCountryDtoFromJSON));
    }

    /**
     * Retrieve allowed investments countries for investments
     */
    async getAllowedInvestmentsCountries(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IInvestmentCountryDto>> {
        const response = await this.getAllowedInvestmentsCountriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get auto investment scheduler by investor account id
     */
    async getAutoInvestmentSchedulerRaw(requestParameters: GetAutoInvestmentSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAutoInvestmentSchedulerResponseDto>> {
        if (requestParameters['investorAccountId'] == null) {
            throw new runtime.RequiredError(
                'investorAccountId',
                'Required parameter "investorAccountId" was null or undefined when calling getAutoInvestmentScheduler().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['investorAccountId'] != null) {
            queryParameters['investor_account_id'] = requestParameters['investorAccountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investment-schedulers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAutoInvestmentSchedulerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get auto investment scheduler by investor account id
     */
    async getAutoInvestmentScheduler(requestParameters: GetAutoInvestmentSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAutoInvestmentSchedulerResponseDto> {
        const response = await this.getAutoInvestmentSchedulerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get performance history
     */
    async getClosestPerformanceHistoryRaw(requestParameters: GetClosestPerformanceHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPerformanceHistoryDto>>> {
        const queryParameters: any = {};

        if (requestParameters['daysBack'] != null) {
            queryParameters['days_back'] = requestParameters['daysBack'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/performance-histories`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPerformanceHistoryDtoFromJSON));
    }

    /**
     * Get performance history
     */
    async getClosestPerformanceHistory(requestParameters: GetClosestPerformanceHistoryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPerformanceHistoryDto>> {
        const response = await this.getClosestPerformanceHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get investor info with pending trade sum by employee id
     */
    async getInvestorByEmployeeIdRaw(requestParameters: GetInvestorByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestorDto>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investors`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvestorDtoFromJSON(jsonValue));
    }

    /**
     * Get investor info with pending trade sum by employee id
     */
    async getInvestorByEmployeeId(requestParameters: GetInvestorByEmployeeIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestorDto> {
        const response = await this.getInvestorByEmployeeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get investors by employee ids
     */
    async getInvestorsByEmployeeIdsRaw(requestParameters: GetInvestorsByEmployeeIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IInvestorBaseDto>>> {
        if (requestParameters['employeeIds'] == null) {
            throw new runtime.RequiredError(
                'employeeIds',
                'Required parameter "employeeIds" was null or undefined when calling getInvestorsByEmployeeIds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employee_ids'] = requestParameters['employeeIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investors/base`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IInvestorBaseDtoFromJSON));
    }

    /**
     * Get investors by employee ids
     */
    async getInvestorsByEmployeeIds(requestParameters: GetInvestorsByEmployeeIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IInvestorBaseDto>> {
        const response = await this.getInvestorsByEmployeeIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get money transfer page
     */
    async getMoneyTransfers1Raw(requestParameters: GetMoneyTransfers1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageMoneyTransferResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = (requestParameters['startDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = (requestParameters['endDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/money-transfers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageMoneyTransferResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get money transfer page
     */
    async getMoneyTransfers1(requestParameters: GetMoneyTransfers1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageMoneyTransferResponseDto> {
        const response = await this.getMoneyTransfers1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve investor orders
     */
    async getOrders1Raw(requestParameters: GetOrders1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPagePublicOrderDto>> {
        const queryParameters: any = {};

        if (requestParameters['instrumentIds'] != null) {
            queryParameters['instrument_ids'] = requestParameters['instrumentIds'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = (requestParameters['startDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = (requestParameters['endDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['minAmount'] != null) {
            queryParameters['min_amount'] = requestParameters['minAmount'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/orders`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPagePublicOrderDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve investor orders
     */
    async getOrders1(requestParameters: GetOrders1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPagePublicOrderDto> {
        const response = await this.getOrders1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve PNL metrics for the investor.
     */
    async getPnlMetricsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IAggregatedPnlMetricDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investors/performance/pnl`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IAggregatedPnlMetricDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve PNL metrics for the investor.
     */
    async getPnlMetrics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IAggregatedPnlMetricDto> {
        const response = await this.getPnlMetricsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Fetch trading history for the current investor account
     */
    async getTradingAmountsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ITradingAmountsDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/trades/amounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ITradingAmountsDtoFromJSON(jsonValue));
    }

    /**
     * Fetch trading history for the current investor account
     */
    async getTradingAmounts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ITradingAmountsDto> {
        const response = await this.getTradingAmountsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Save employment profile and investor profile - UI step 3
     */
    async patchQuestionnaireRaw(requestParameters: PatchQuestionnaireRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvestorDto>> {
        if (requestParameters['iQuestionnaireDto'] == null) {
            throw new runtime.RequiredError(
                'iQuestionnaireDto',
                'Required parameter "iQuestionnaireDto" was null or undefined when calling patchQuestionnaire().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investments/flows/questionnaire`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IQuestionnaireDtoToJSON(requestParameters['iQuestionnaireDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvestorDtoFromJSON(jsonValue));
    }

    /**
     * Save employment profile and investor profile - UI step 3
     */
    async patchQuestionnaire(requestParameters: PatchQuestionnaireRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvestorDto> {
        const response = await this.patchQuestionnaireRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Propose investment portfolios
     */
    async proposePortfolioRaw(requestParameters: ProposePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPortfolioFundAssetDto>>> {
        if (requestParameters['investorId'] == null) {
            throw new runtime.RequiredError(
                'investorId',
                'Required parameter "investorId" was null or undefined when calling proposePortfolio().'
            );
        }

        if (requestParameters['riskModel'] == null) {
            throw new runtime.RequiredError(
                'riskModel',
                'Required parameter "riskModel" was null or undefined when calling proposePortfolio().'
            );
        }

        if (requestParameters['amount'] == null) {
            throw new runtime.RequiredError(
                'amount',
                'Required parameter "amount" was null or undefined when calling proposePortfolio().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['investorId'] != null) {
            queryParameters['investor_id'] = requestParameters['investorId'];
        }

        if (requestParameters['riskModel'] != null) {
            queryParameters['risk_model'] = requestParameters['riskModel'];
        }

        if (requestParameters['amount'] != null) {
            queryParameters['amount'] = requestParameters['amount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investment-portfolios/proposed`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPortfolioFundAssetDtoFromJSON));
    }

    /**
     * Propose investment portfolios
     */
    async proposePortfolio(requestParameters: ProposePortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPortfolioFundAssetDto>> {
        const response = await this.proposePortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve available instrument ids for current investor account
     */
    async retrieveCurrentInvestorAccountInstrumentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Set<IInstrumentDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/instruments/current-investor-account`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => new Set(jsonValue.map(IInstrumentDtoFromJSON)));
    }

    /**
     * Retrieve available instrument ids for current investor account
     */
    async retrieveCurrentInvestorAccountInstruments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Set<IInstrumentDto>> {
        const response = await this.retrieveCurrentInvestorAccountInstrumentsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all instrument category types
     */
    async retrieveInstrumentCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IInstrumentCategoryTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/instruments/categories`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IInstrumentCategoryTypeDtoFromJSON));
    }

    /**
     * Retrieve all instrument category types
     */
    async retrieveInstrumentCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IInstrumentCategoryTypeDto>> {
        const response = await this.retrieveInstrumentCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve instruments by search value and categories
     */
    async retrieveSelfDirectedInstrumentsRaw(requestParameters: RetrieveSelfDirectedInstrumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageInstrumentDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['categoryTypes'] != null) {
            queryParameters['category_types'] = requestParameters['categoryTypes'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/instruments/self-directed`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageInstrumentDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve instruments by search value and categories
     */
    async retrieveSelfDirectedInstruments(requestParameters: RetrieveSelfDirectedInstrumentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageInstrumentDto> {
        const response = await this.retrieveSelfDirectedInstrumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update risk tolerance model
     */
    async updateRiskToleranceModelRaw(requestParameters: UpdateRiskToleranceModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IRiskToleranceModelResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateRiskToleranceModel().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling updateRiskToleranceModel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/investors/{id}/risk-tolerance-model`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IRiskToleranceModelResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update risk tolerance model
     */
    async updateRiskToleranceModel(requestParameters: UpdateRiskToleranceModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IRiskToleranceModelResponseDto> {
        const response = await this.updateRiskToleranceModelRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum ApproveAndOnboardInvestorModelEnum {
    CONSERVATIVE = 'CONSERVATIVE',
    MODERATELY_CONSERVATIVE = 'MODERATELY_CONSERVATIVE',
    MODERATE = 'MODERATE',
    MODERATELY_AGGRESSIVE = 'MODERATELY_AGGRESSIVE',
    AGGRESSIVE = 'AGGRESSIVE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetMoneyTransfers1StatusesEnum {
    CREATED_INTERNAL = 'CREATED_INTERNAL',
    CREATED_EXTERNAL = 'CREATED_EXTERNAL',
    SUCCESSFUL_EXTERNAL = 'SUCCESSFUL_EXTERNAL',
    PENDING_PAYMENT = 'PENDING_PAYMENT',
    PAID = 'PAID',
    FAILED_EXTERNAL = 'FAILED_EXTERNAL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetOrders1StatusEnum {
    FILLED = 'FILLED',
    PARTIAL_FILL = 'PARTIAL_FILL',
    REJECTED = 'REJECTED',
    CANCELED = 'CANCELED',
    NEW = 'NEW',
    PENDING_CANCEL = 'PENDING_CANCEL',
    EXPIRED = 'EXPIRED',
    WAITING_APPROVAL = 'WAITING_APPROVAL',
    PAID = 'PAID'
}
/**
  * @export
  * @enum {string}
  */
export enum ProposePortfolioRiskModelEnum {
    CONSERVATIVE = 'CONSERVATIVE',
    MODERATELY_CONSERVATIVE = 'MODERATELY_CONSERVATIVE',
    MODERATE = 'MODERATE',
    MODERATELY_AGGRESSIVE = 'MODERATELY_AGGRESSIVE',
    AGGRESSIVE = 'AGGRESSIVE'
}
/**
  * @export
  * @enum {string}
  */
export enum RetrieveSelfDirectedInstrumentsCategoryTypesEnum {
    SHORT_TERM_BOND = 'SHORT_TERM_BOND',
    INTERMEDIATE_CORE_BOND = 'INTERMEDIATE_CORE_BOND',
    INTERMEDIATE_CORE_PLUS_BOND = 'INTERMEDIATE_CORE_PLUS_BOND',
    INFLATION_PROTECTED_BOD = 'INFLATION_PROTECTED_BOD',
    GLOBAL_BOND = 'GLOBAL_BOND',
    HIGH_YIELD_BOND = 'HIGH_YIELD_BOND',
    LARGE_VALUE = 'LARGE_VALUE',
    LARGE_BLEND = 'LARGE_BLEND',
    LARGE_GROWTH = 'LARGE_GROWTH',
    MID_CAP_VALUE = 'MID_CAP_VALUE',
    MID_CAP_BLEND = 'MID_CAP_BLEND',
    MID_CAP_GROWTH = 'MID_CAP_GROWTH',
    SMALL_VALUE = 'SMALL_VALUE',
    SMALL_BLEND = 'SMALL_BLEND',
    SMALL_GROWTH = 'SMALL_GROWTH',
    REAL_ESTATE = 'REAL_ESTATE',
    FOREIGN_LARGE_BLEND = 'FOREIGN_LARGE_BLEND',
    FOREIGN_SMALL_MID_BLEND = 'FOREIGN_SMALL_MID_BLEND',
    DIVERSIFIED_EMERGING_MKTS = 'DIVERSIFIED_EMERGING_MKTS',
    MONEY_MARKET_FUND = 'MONEY_MARKET_FUND'
}
